export enum ListViewItemDefinitionOptionKey {
    DisplayBooleanAsIcon = 'DisplayBooleanAsIcon',
    BooleanDisplayTrueValue = 'BooleanDisplayTrueValue',
    BooleanDisplayFalseValue = 'BooleanDisplayFalseValue',
}
